import React from 'react';
import './Common.css';

interface FilterBarProps {
  onSearch?: (value: string) => void;
  searchPlaceholder?: string;
  startDate?: string;
  endDate?: string;
  onStartDateChange?: (value: string) => void;
  onEndDateChange?: (value: string) => void;
  onReset?: () => void;
  children?: React.ReactNode;
}

const FilterBar: React.FC<FilterBarProps> = ({
  onSearch, searchPlaceholder = '검색...', startDate, endDate,
  onStartDateChange, onEndDateChange, onReset, children
}) => (
  <div className="filter-bar">
    {onSearch && (
      <input type="text" className="filter-bar__input" placeholder={searchPlaceholder}
        onChange={(e) => onSearch(e.target.value)} />
    )}
    {onStartDateChange && (
      <input type="date" className="filter-bar__date" value={startDate || ''} onChange={(e) => onStartDateChange(e.target.value)} />
    )}
    {onEndDateChange && (
      <input type="date" className="filter-bar__date" value={endDate || ''} onChange={(e) => onEndDateChange(e.target.value)} />
    )}
    {children}
    {onReset && <button className="btn btn--secondary btn--sm" onClick={onReset}>초기화</button>}
  </div>
);

export default FilterBar;
